import React from 'react';
import { BulkConfiguration } from './bulk-configuration/bulk-configuration';
import { BulkEntry } from './bulk-entry/bulk-entry';
import type { BulkConfigurationSettings, BulkDraftProjection, BulkDraftSubmissionFilter } from './bulk-drafts-types';
import { BulkPreview } from './bulk-preview/bulk-preview';

interface BulkOrderProps {
    onSubmit: (submissionFilter: BulkDraftSubmissionFilter) => void;
}

export const BulkDrafts = (props: BulkOrderProps) => {
    const { onSubmit } = props;

    const [bulkTabIndex, setBulkTabIndex] = React.useState(0);
    const [bulkConfiguration, setBulkConfiguration] = React.useState<BulkConfigurationSettings | null>(null);
    const [projections, setProjections] = React.useState<BulkDraftProjection[]>([]);

    function onBulkConfigurationChange(bulkConfiguration: BulkConfigurationSettings) {
        setBulkConfiguration(bulkConfiguration);
        setBulkTabIndex(1);
    }

    function handleBack() {
        setBulkTabIndex((prev: number) => prev - 1);
    }

    return (
        <div style={{ width: '80rem', height: '72vh' }} data-testid='bulk-order'>
            {bulkTabIndex === 0 &&
                <BulkConfiguration bulkConfiguration={bulkConfiguration} setBulkConfiguration={onBulkConfigurationChange}/>
            }
            {bulkTabIndex === 1 && bulkConfiguration &&
                <BulkEntry
                    bulkConfiguration={bulkConfiguration}
                    previewLoads={(projections: BulkDraftProjection[]) => {
                        setProjections(projections);
                        setBulkTabIndex(2);
                    }}
                    handleBack={handleBack}
                />
            }
            {bulkTabIndex === 2 && bulkConfiguration && projections &&
                <BulkPreview
                    bulkConfiguration={bulkConfiguration}
                    projections={projections}
                    onSubmit={onSubmit}
                    handleBack={handleBack}
                />
            }
        </div>
    );
};